import { toPersianDigits } from '@bookora/shared';
/**
 * The engine's own words. A single digit between two words is bidi-safe, so
 * «۲ از ۴» needs no isolate.
 */
export const DEFAULT_COACHMARK_LABELS = {
    next: 'بعدی',
    prev: 'قبلی',
    finish: 'متوجه شدم',
    skip: 'رد کردن راهنما',
    close: 'بستن راهنما',
    backToGuide: 'بازگشت به راهنما',
    counter: (n, total) => `${toPersianDigits(n)} از ${toPersianDigits(total)}`,
    liveStep: (n, total, title) => `مرحلهٔ ${toPersianDigits(n)} از ${toPersianDigits(total)}: ${title}`,
};
//# sourceMappingURL=labels.js.map